import { Controller } from "@hotwired/stimulus"

// Shows the parts of a form that belong to the choice made (report sending, 29.10.2026):
// an element with data-reveal-field="name" data-reveal-values="a,b" is shown only while
// the checked radio (or the select) of that name has one of those values.
export default class extends Controller {
  connect() { this.update() }

  update() {
    this.element.querySelectorAll("[data-reveal-field]").forEach((part) => {
      const name = part.dataset.revealField
      const chosen = this.element.querySelector(`input[name="${name}"]:checked`)?.value ?? this.element.querySelector(`select[name="${name}"]`)?.value
      const show = part.dataset.revealValues.split(",").includes(chosen)
      part.hidden = !show
      part.querySelectorAll("input, select, textarea").forEach((field) => { field.disabled = !show })
    })
  }
}
